import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Data.Controller.EXPO_RandomPointExt = (function(){

    var Cache = WRAP.Cache;
    var request = [];
    var loading = {};

    function getCache(key) {
        var cached = Cache.get(key);
        return cached && cached.data;
    }

    function getError(key) {
        var cached = Cache.get(key);
        return cached && cached.error;
    }

    function setCache(key, data, size, ds, error) {
        Cache.set(key, data, size, ds, error);
    }

    function makeTileKey(data, tile) {
        var t = data.control.update_end_time || "-";
        var name = data.conf.data.Name;
        return "EXPO_RandomPoint/"+name+"/"+t+"/"+tile.z+"/"+tile.y+"/"+tile.x;
    }

    function load(source) {
        if ( source.data )
            return;
        if ( loading[source.key] )
            return;
        loading[source.key] = true;
        //console.log("load:"+source.key);        
        source.query.load(source.option, false,
            function(data) {
                //console.log(" success:"+source.key);        
                var root = makeGeoObject(data);
                setCache(source.key, root, JSON.stringify(root).length+256, source.ds);
                updateRequest();
                delete loading[source.key];
            },
            function(url, status) {
                //console.log(" error:"+source.key);        
                source.error = true;
                source.data = {error:true};
                setCache(source.key, {}, 256, source.ds, {url:url, status:status});
                updateRequest();
                delete loading[source.key];
            }
        );
    }

    function makeGeoObject(points) {
        var root = {
            type: "FeatureCollection",
            properties:{},
            features:[]
        };
        for ( var key in points ) {
            var item = points[key];
            if ( key == 'data' ) {
//console.debug("EXPO random point="+item.length);                            
                for ( var i = 0 ; i < item.length ; i++ ) {
                    var point = item[i];
                    var t = point.valid_time;
                    if ( t ) {
                        if ( t.length > 19 )
                            t = t.substr(0,19);
                        var vt = new WRAP.Core.DateTime(t);
                        var feature = {
                            geometry:{
                                type:"Point",
                                coordinates:[point.LOND, point.LATD]
                            },
                            properties: {
                                obs_time:vt.text()
                            }
                        }
                        root.features.push(feature)
                    }
                    for ( var k in point )
                        feature.properties[k] = point[k];
                }
            }
            else {
                root.properties[key] = item;
            }
        }
        return root;
    }

    function updateRequest() {
        var r = [].concat(request);
        for ( var i = 0 ; i < r.length ; i++ )
            processRequest(r[i], true)
    }

    function processRequest(r/*, loaded*/) {
        var result = [];
        var error = [];
        var processed = 0;
        for ( var i = 0 ; i < r.source.length ; i++ ) {
            var source = r.source[i];
            if ( !source.data ) {
                source.data = getCache(source.key);
                source.error = getError(source.key);
            }
            if ( source.data )
                processed++;
            if ( source.error )
                error.push(source.error);
            result.push(source.data);
        }
        //if ( loaded && r.progress ) { // remove for asynchronus draw
        if ( r.progress ) {
            r.progress(processed, r.source.length, result)
        }
        if ( r.source.length != processed )
            return;

        if ( r.error ) {
            for ( var i = 0 ; i < error.length ; i++ )
                r.error(error[i]);
        }
        if ( r.success )
            r.success(result);
        var index = request.indexOf(r);
        if ( index >=0 )
            request.splice(index, 1);
    }

    return {
        init: function(data) {
            data.control = {
                state: {
                    retained:null,
                    error:null,
                    revision:0
                },
                update_begin_time:null,
                update_end_time:null
            };
        },

        derive: function(data, id, option, force, completed, error, progress) {
            force; error; progress;
            if ( id != 'data' ) 
                return;
            if ( !option )
                option = {};
            var auto_update = (!completed && !error && !progress);
            var conf = data.conf[id]; 
            var ds = data.source;
            if ( option.begin_time && option.end_time ) {
                data.control.update_begin_time = option.begin_time;
                data.control.update_end_time = option.end_time;
            }
            else {
                var t = WRAP.Core.currentTime();
                var range = parseInt(conf.TimeRange) || 3600;
                data.control.update_end_time = t.text('YYYY-MM-DDThh:mm:ssZ');
                t.add(-range);
                data.control.update_begin_time = t.text('YYYY-MM-DDThh:mm:ssZ');
            }

            if ( auto_update ) {
                if ( conf.separation ) {
                    data._inspector(ds.data);
                    ds[id].autoUpdate();
                    return;
                }
            }
            
            option.begin_time = data.control.update_begin_time;
            option.end_time = data.control.update_end_time;
            var tile_key = makeTileKey(data, {z:0, y:0, x:0});
            //console.log("auto update load")            
            ds.query.load(option, false,
                function(points) {
                    //console.log("auto update loaded")            
                    var root = makeGeoObject(points);
                    setCache(tile_key, root, JSON.stringify(root).length+256, ds.data);
                    data.control.state.retained = root;
                    data.control.state.status = 'completed';
                    data.control.state.revision++;
                    data._update('data', data.control.state);
                    if ( completed )
                        completed(data.control.state.retained);
                    if ( auto_update ) {
                        data._inspector(ds.data);
                        ds[id].autoUpdate();
                    }
                },
                function() {
                    data.control.state.retained = null;
                    data.control.state.status = 'error';
                    data.control.state.revision++;
                    data._update('data', data.control.state);
                    if ( completed )
                        completed(null);
                    if ( auto_update ) {
                        ds[id].autoUpdate();
                    }
                }
            );
        },

        getGeoObject: function(data, id, bounds, option, sampling, success, error, progress, request_key) {
            var ds = data.source[id];
            if ( !ds || id != 'data' )
                return;
            if ( !data.control.update_end_time )
                return;

            var z = parseInt(ds.conf.separation);
            if ( isNaN(z) )
                z = 0;
            var sep = Math.pow(2, z);
            var interval = 360/sep;

            var tiles = {};
            if ( z == 0 ) {
                tiles["0/0/0"] = {z:0,y:0,x:0};
            }
            else {
                for ( var i = 0 ; i < bounds.length ; i++ ) {
                    var b = bounds[i];
                    var sy = Math.floor((90-b.north)/interval);
                    var ey = Math.floor((90-b.south)/interval);
                    var sx = Math.floor(b.west/interval);
                    var ex = Math.floor(b.east/interval);
                    for ( var y = sy ; y <= ey ; y++ ) {
                        for ( var x = sx ; x <= ex ; x++ ) {
                            var yy = (y+sep)%sep;
                            var xx = (x+sep)%sep;
                            var tid = ""+z+"/"+yy+"/"+xx;
                            if ( !tiles[tid] )
                                tiles[tid] = {z:z, y:yy, x:xx};
                        }
                    }
                }
            }

            //var num = Object.keys(tiles).length;
            //console.log("=== tiles:"+num);

            var req = {
                key:request_key,
                source:[]
            }
            var wait = [];

            var conf = data.conf[id]; 
            var bbox = {
                north: 80,
                south: -80,
                west: 0,
                east: 360,
            } 
            if ( conf.BoundingBox ) {
                bbox.west = conf.BoundingBox.West;
                bbox.east = conf.BoundingBox.East;
                bbox.north = conf.BoundingBox.North;
                bbox.south = conf.BoundingBox.South;
            }

            for ( var tid  in tiles ) {
                var tile = tiles[tid];
                var tile_north = 90-tile.y*interval;
                var tile_south = tile_north-interval;
                var tile_west = tile.x*interval;
                var tile_east = tile_west+interval;
                if ( tile_north > 90 )
                    tile_north = 90;
                if ( tile_south < -90 )
                    tile_south = -90;
                
                if ( 
                    (tile_south > bbox.north) ||
                    (tile_north < bbox.south) || 
                    (tile_east < bbox.west) || 
                    (tile_west > bbox.east) )
                { // tile  is completely out of bounds
                    continue;
                }
                else {

                    var tile_key = makeTileKey(data, tile);
                    //console.log("  tile="+tile_key);
                    var source = {
                        query:data.source.query,
                        ds:ds,
                        option:{},
                        key:tile_key,
                        tile:tile,
                        data:getCache(tile_key),
                        error:getError(tile_key)
                    };
                    var option = source.option;
                    option.begin_time = data.control.update_begin_time;
                    option.end_time = data.control.update_end_time;

                    option.north = tile_north;
                    option.south = tile_south;
                    option.east = tile_east;
                    option.west = tile_west;

                    if (tile_north > bbox.north) {
                        option.north = bbox.north;
                    }
                    if (tile_south < bbox.south) {
                        option.south = bbox.south;
                    }
                    if (tile_east > bbox.east) {
                        option.east = bbox.east;
                    }
                    if (tile_west < bbox.west) {
                        option.west =  bbox.west;
                    }

                    if ( !source.data )
                        wait.push(source);
                    req.source.push(source);
                }
            }

            req.success = success;
            req.error = error;
            req.progress = progress;
            request.push(req);
            processRequest(req); // for asynchronus draw
            for ( var i = 0 ; i < wait.length ; i++ )
                load(wait[i]);
        },

        cancel : function(data, id, force, key) {
            for ( var i = 0 ; i < request.length ; i++ ) {
                var rk = request[i].key; 
                if ( rk == key )
                    request.splice(i--, 1);
            }
        },

        //TimeControllerに対応
        modifyContent: function(data, option) {
            if ( option && option.begin_time && option.end_time) {
                data.control.update_begin_time = option.begin_time;
                data.control.update_end_time = option.end_time;
                return true;
            }
        }
        
    }
}());
/* eslint-enable */